import i18n from "i18n";
import { METRIC_COLUMN_IDS, getMetricColumnTitle } from "components/inputs/InputsOveriew/metricColumns";
const getInputsTableElements = () => {
  const tableLayout = {
    entityTableId: "inputs",
    defaultPageSize: 50,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: [
      "title",
      "type",
      "direction",
      "desired_state",
      "traffic",
      "input_failures",
      "node_id",
      "address",
      "port"
    ],
    defaultColumnOrder: [
      "title",
      "type",
      "direction",
      "desired_state",
      "traffic",
      "input_failures",
      METRIC_COLUMN_IDS.messagesPerStream,
      METRIC_COLUMN_IDS.extractorCount,
      METRIC_COLUMN_IDS.associatedStreams,
      "node_id",
      "address",
      "port"
    ]
  };
  const additionalAttributes = [
    { id: "traffic", title: i18n.t("overview.columns.traffic", { ns: "inputs" }) },
    { id: "input_failures", title: i18n.t("overview.columns.input_failures", { ns: "inputs" }) },
    { id: "address", title: i18n.t("overview.columns.address", { ns: "inputs" }) },
    { id: "port", title: i18n.t("overview.columns.port", { ns: "inputs" }), type: "INT" },
    {
      id: METRIC_COLUMN_IDS.messagesPerStream,
      title: getMetricColumnTitle(METRIC_COLUMN_IDS.messagesPerStream)
    },
    {
      id: METRIC_COLUMN_IDS.extractorCount,
      title: getMetricColumnTitle(METRIC_COLUMN_IDS.extractorCount),
      type: "INT"
    },
    {
      id: METRIC_COLUMN_IDS.associatedStreams,
      title: getMetricColumnTitle(METRIC_COLUMN_IDS.associatedStreams)
    }
  ];
  return {
    tableLayout,
    additionalAttributes
  };
};
export default getInputsTableElements;
